module.exports = __webpack_public_path__ + "static/media/logo.6dbcb91e.png";